import { useMutation } from 'react-query';
import { validateInvitation } from 'src/services/api/invitations';

function useValidateInvitation() {
  return useMutation((invitation) => validateInvitation(invitation));
}

export default useValidateInvitation;
